import { useEffect, useState } from "react";
import { SectionHeading } from "./kit";
import { RegisterForm } from "./RegisterForm";
import { DonateNow, GiveawayRules, GiveawayPrizes } from "./Support";

export const JoinSection = ({ content }) => {
  const [volunteerSignal, setVolunteerSignal] = useState(0);

  useEffect(() => {
    const sync = () => {
      if (window.location.hash !== "#volunteer") return;
      setVolunteerSignal((n) => n + 1);
      document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });
    };
    sync();
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, []);

  return (
    <section id="register" className="px-5 py-20 md:py-28" data-testid="register-section">
      <span id="volunteer" className="block -translate-y-20" aria-hidden />
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <SectionHeading eyebrow="Join us" title="Register, volunteer &" accent="support">
          Register your household so the hosts can prepare food, seating and ceremony. Tick the boxes to volunteer or to support the festival with a donation of $5 or more.
        </SectionHeading>
        <div className="space-y-6">
          <RegisterForm content={content} volunteerSignal={volunteerSignal} />
          <DonateNow content={content} />
          <GiveawayPrizes content={content} />
          <GiveawayRules content={content} />
        </div>
      </div>
    </section>
  );
};
